var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRegaloRojo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48.1 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_1-2",
    "data-name": "Capa_1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Componente_28_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_162304-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "gift-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_83167-2",
    d: "M46.2,23v24H1.9v-24",
    fill: "none",
    stroke: "#a51414",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_147607-2",
    x: 1,
    y: 13.6,
    width: 46.1,
    height: 9.4,
    fill: "none",
    stroke: "#a51414",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_232-2",
    x1: 23.9,
    y1: 47,
    x2: 23.9,
    y2: 14.4,
    fill: "none",
    stroke: "#a51414",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_83168-2",
    d: "M21.4,11.2h-9.3c-2.8,0-5.1-2.3-5.1-5.1S9.3,1,12.1,1c7.2,0,9.3,10.3,9.3,10.3v-.1Z",
    fill: "none",
    stroke: "#a51414",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_83169-2",
    d: "M26.4,11.2h9.3c2.8,0,5.1-2.3,5.1-5.1s-2.3-5.1-5.1-5.1h0c-7.2,0-9.3,10.3-9.3,10.3v-.1Z",
    fill: "none",
    stroke: "#a51414",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRegaloRojo);
export default __webpack_public_path__ + "static/media/regalo_rojo.bf17d65f977dc29884b4cd122344caf9.svg";
export { ForwardRef as ReactComponent };